import {createActions} from 'reduxsauce';

export const {Types: OrEtArgentTypes, Creators: OrEtArgentActionCreators} = createActions ({
    orEtArgentStart: ['selectedItem'],
    orEtArgentSuccess: ['data'],
    orEtArgentFailure: ['error']
});